import type { ReactNode } from "react";

import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from "@/components/ui/card";
import { Button } from "@/components/ui/button";

type Action = {
  label: string;
  onClick: () => void;
  variant?:
    | "default"
    | "outline"
    | "secondary"
    | "destructive"
    | "ghost"
    | "link";
};

interface ErrorFallbackBaseProps {
  title: string;
  description?: string;
  primaryAction?: Action;
  secondaryAction?: Action;
  icon?: ReactNode;
}

export function ErrorFallbackBase({
  title,
  description,
  primaryAction,
  secondaryAction,
  icon,
}: ErrorFallbackBaseProps) {
  return (
    <div className="flex h-full w-full items-center justify-center p-4">
      <Card className="max-w-md w-full">
        <CardHeader className="space-y-2">
          <div className="flex items-center gap-2">
            {icon}
            <CardTitle className="text-lg">{title}</CardTitle>
          </div>
          {description ? (
            <CardDescription>{description}</CardDescription>
          ) : null}
        </CardHeader>
        {(primaryAction || secondaryAction) && (
          <CardContent className="flex flex-wrap gap-3 pt-4">
            {primaryAction ? (
              <Button
                type="button"
                variant={primaryAction.variant ?? "default"}
                onClick={primaryAction.onClick}
              >
                {primaryAction.label}
              </Button>
            ) : null}
            {secondaryAction ? (
              <Button
                type="button"
                variant={secondaryAction.variant ?? "outline"}
                onClick={secondaryAction.onClick}
              >
                {secondaryAction.label}
              </Button>
            ) : null}
          </CardContent>
        )}
      </Card>
    </div>
  );
}
